/*
 * @Author: mayanxia 
 * @Date: 2020-11-07 19:54:06 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-12-22 10:28:39
 */

<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" :label="$t('上级标题')" hasFeedback prop="knowledgeParentId">
              <a-tree-select
                style="width:100%"
                :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                :treeData="treeData"
                v-model="model.knowledgeParentId"
                :replaceFields="replaceFields"
                :placeholder="$t('请选择上级区域')"
                :disabled="condition">
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('标题名称')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="knowledgeName">
              <a-input v-model="model.knowledgeName" :placeholder="$t('请输入标题名称')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('知识内容')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content">
              <j-editor v-model="model.content"></j-editor>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('内容附件')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import {queryAreaTreeList} from '@/api/api'
  import pick from 'lodash.pick'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import JUpload from '@/components/jeecg/JUpload'
  import JEditor from '@/components/jeecg/JEditor'
  export default {
    name: "SysDepartModal",
    components: { ATextarea,JUpload,JEditor },
    data () {
      return {
        treeData:[],
        phoneWarning:'',
        title:this.$t('操作'),
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {
          knowledgeName: '',
          knowledgeParentId: '',
          content: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-hotline/knowledge/knowledge/add",
          queryAreaTreeList: "/jeecg-hotline/knowledge/knowledge/queryAreaTreeList",
        },
        replaceFields: {
          children: 'children',
          title: 'knowledgeName',
          key: 'id',
          value: 'id'
        },
        fileList: []
      }
    },
    created () {
    },
    // i18n：校验规则使用 computed 以响应语言切换
    computed: {
      rules() {
        return {
          knowledgeName: [{required: true, message: this.$t('请输入标题名称!')}],
          content: [{required: true, message: this.$t('请输入知识内容!')}],
        }
      },
    },
    methods: {
      uploadChange(file){
        this.model.contentAnnex = file;
        this.$refs.form.validateField('contentAnnex');
      },
      loadTreeData(record) {
        var that = this;
        getAction(this.url.queryAreaTreeList).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
          }
        })
      },
      add (depart) {
        if(depart){
          this.seen = false;
        }else{
          this.seen = true;
        }
        this.edit(depart);
      },
      edit (record) {
        this.treeData = []
        this.model = Object.assign(this.model, {});
        this.visible = true;
        this.loadTreeData(record);
        this.$nextTick(() => {
          this.$refs.formModal.resetFields();
          this.model.knowledgeParentId = record!==null?record.toString():null;
        })
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let params = this.model;
            params.knowledgeItem = {
              content: this.model.content,
              contentAnnex: this.model.contentAnnex,
            }
            httpAction(this.url.add,params,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.error(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          callback();
        }else{
          callback(this.$t("您的手机号码格式不正确!"));
        }
      },
      
    }
  }
</script>

<style scoped>

</style>